import React, { useEffect } from 'react';
import { Card, Row, Col, Badge } from 'react-bootstrap';
import { FolderOpen, Coffee, Store, Grid3X3, CheckCircle, Star } from 'lucide-react';
import { useAdminMenu } from '../../context/AdminMenuContext';

const AdminStats = () => {
  const { stats, fetchStats, loading, statsError } = useAdminMenu();

  useEffect(() => {
    fetchStats();
  }, [fetchStats]);

  const statCards = [
    {
      title: 'Tổng số món',
      value: stats?.totalItems || 0,
      icon: Coffee,
      color: 'primary',
      bgColor: 'primary',
    },
    {
      title: 'Món đang bán',
      value: stats?.availableItems || 0,
      icon: CheckCircle,
      color: 'success',
      bgColor: 'success',
    },
    {
      title: 'Món nổi bật',
      value: stats?.featuredItems || 0,
      icon: Star,
      color: 'warning',
      bgColor: 'warning',
    },
    {
      title: 'Danh mục',
      value: stats?.totalCategories || 0,
      icon: FolderOpen,
      color: 'info',
      bgColor: 'info',
    },
    {
      title: 'Chi nhánh',
      value: stats?.totalBranches || 0,
      icon: Store,
      color: 'secondary',
      bgColor: 'secondary',
    },
    {
      title: 'Số bàn',
      value: stats?.totalTables || 0,
      icon: Grid3X3,
      color: 'dark',
      bgColor: 'dark',
    },
  ];

  if (loading) {
    return (
      <div className="text-center py-5">
        <div
          className="spinner-border text-primary"
          role="status"
        >
          <span className="visually-hidden">Đang tải...</span>
        </div>
      </div>
    );
  }

  if (statsError) {
    return (
      <div className="admin-stats">
        <Card className="mb-4 border-danger">
          <Card.Body className="text-danger">
            Không tải được thống kê tổng quan: {statsError?.message || 'Có lỗi xảy ra'}
          </Card.Body>
        </Card>
      </div>
    );
  }

  return (
    <div className="admin-stats">
      <Card className="mb-4">
        <Card.Header className="bg-white">
          <h4 className="mb-0">Thống kê tổng quan</h4>
          <small className="text-muted">Tổng quan về menu và chi nhánh của hệ thống</small>
        </Card.Header>
      </Card>

      <Row className="g-3">
        {statCards.map((stat, index) => {
          const Icon = stat.icon;
          return (
            <Col
              key={index}
              xs={12}
              sm={6}
              lg={4}
            >
              <Card className="h-100 shadow-sm">
                <Card.Body>
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <div
                        className="text-muted mb-1"
                        style={{ fontSize: '0.875rem' }}
                      >
                        {stat.title}
                      </div>
                      <h3 className="mb-0">{stat.value}</h3>
                    </div>
                    <div
                      className={`d-flex align-items-center justify-content-center rounded-circle bg-${stat.bgColor} bg-opacity-10`}
                      style={{ width: '60px', height: '60px' }}
                    >
                      <Icon
                        size={30}
                        className={`text-${stat.color}`}
                      />
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default AdminStats;
